const d = (s, o = []) => {
  const e = {
    ...s
  };
  for (const t in e)
    t.startsWith("cq") && delete e[t];
  for (const t of o)
    delete e[t];
  return delete e.model, delete e.directProps, delete e.dataTestId, e;
};
export {
  d as s
};
